import React from "react";
import * as queryString from "querystring";
import { useLocation } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { useAuthProvider } from "./hooks/useAuthProvider";
import Loading from "../../components/Loading";

export const AuthContext = React.createContext<
  Partial<ReturnType<typeof useAuthProvider>>
>({});

export const AuthProvider: React.FC = ({ children }) => {
  const location = useLocation();
  const provider = useAuthProvider();

  const {
    user,
    data: { authorizing },
    actions: { authorize },
  } = provider;

  let queryParams = queryString.parse(location.search.split("?").join(""));
  let token: any = queryParams.auth_token;

  React.useEffect(() => {
    authorize(token);
  }, [token, authorize]);

  if (authorizing) return <Loading />;

  if (user && token) return <Redirect to={location.pathname} />;

  return (
    <AuthContext.Provider value={provider}>{children}</AuthContext.Provider>
  );
};
